"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendOrderOption = void 0;
var qs = require('qs');
// [Backend OrderOption]
exports.backendOrderOption = function (axios) {
    return {
        getOrderOptionsOrderGrid: function (getOrderOptionsOrderGridRequest) {
            return axios.get('/order-options/order-grid', getOrderOptionsOrderGridRequest);
        },
        getOrderOptionsDeliveryGrid: function (getOrderOptionsDeliveryGridRequest) {
            return axios.get('/order-options/delivery-grid', getOrderOptionsDeliveryGridRequest);
        },
        getOrderOptionsOrderGridInfo: function () {
            return axios.get('/order-options/order-grid/info');
        },
        getOrderOptionsUserOrderCrm: function (getOrderOptionsUserOrderCrmRequest) {
            return axios.get('/order-options/user-order-crm', getOrderOptionsUserOrderCrmRequest);
        },
        getOrderOptionsSetOrderGrid: function (getOrderOptionsSetOrderGridRequest) {
            return axios.get('/order-options/set-order-grid', getOrderOptionsSetOrderGridRequest);
        },
        putOrderOptionChangeStatus: function (putOrderOptionChangeStatusRequest) {
            return axios.put('/order-options/change-status', putOrderOptionChangeStatusRequest.data);
        },
        putOrderOptionHoldDelivery: function (putOrderOptionHoldDeliveryRequest) {
            var params = qs.stringify(putOrderOptionHoldDeliveryRequest.params);
            return axios.put("/order-options/hold-delivery?" + params, putOrderOptionHoldDeliveryRequest.data);
            // return axios.put('/order-options/hold-delivery?orderOptionNos=' + putOrderOptionHoldDeliveryRequest.params.orderOptionNos);
        },
        getOrderOptionsMallDelaySummary: function (getOrderOptionsMallDelaySummaryRequest) {
            return axios.get('/order-options/mall-delay-summary', getOrderOptionsMallDelaySummaryRequest);
        },
        getOrderOptionsNaverDelaySummary: function (getOrderOptionsNaverDelaySummaryRequest) {
            return axios.get('/order-options/naver-delay-summary', getOrderOptionsNaverDelaySummaryRequest);
        },
        getOrderOptionsPartnerDelaySummary: function (getOrderOptionsPartnerDelaySummaryRequest) {
            return axios.get('/order-options/partner-delay-summary', getOrderOptionsPartnerDelaySummaryRequest);
        },
        getOrderOptionsAbleToCombineShipping: function (getOrderOptionsAbleToCombineShippingRequest) {
            return axios.get('/order-options/able-to-combine-shipping', getOrderOptionsAbleToCombineShippingRequest);
        },
        postOrderOptionsCheckDivideShipping: function (postOrderOptionsCheckDivideShippingRequest) {
            return axios.post('/order-options/check-divide-shipping', postOrderOptionsCheckDivideShippingRequest.data);
        },
        getOrderOptionsExcel: function (getOrderOptionsExcelRequest) {
            return axios.get('/order-options/excel', getOrderOptionsExcelRequest);
        },
        getOrderOptionsDeliveryGridExcel: function (getOrderOptionsDeliveryGridExcelRequest) {
            return axios.get('/order-options/delivery-grid/excel', getOrderOptionsDeliveryGridExcelRequest);
        },
        getOrderOptionsDeliveryReleaseGridExcel: function (getOrderOptionsDeliveryReleaseGridExcelRequest) {
            return axios.get('/order-options/delivery-release-grid/excel', getOrderOptionsDeliveryReleaseGridExcelRequest);
        },
        getOrderOptionsDeliveryHoldSummary: function (getOrderOptionsDeliveryHoldSummaryRequest) {
            return axios.get('/order-options/delivery-hold-summary', getOrderOptionsDeliveryHoldSummaryRequest);
        },
        getOrderOptionsSaleSummaryMall: function (getOrderOptionsSaleSummaryMallRequest) {
            return axios.get('/order-options/sale-summary-mall', getOrderOptionsSaleSummaryMallRequest);
        },
        getOrderOptionsSaleSummaryMallPartner: function () {
            return axios.get('/order-options/sale-summary-partner');
        },
        putOrderOptionsReleaseHoldDelivery: function (putOrderOptionsReleaseHoldDeliveryRequest) {
            return axios.put('/order-options/release-hold-delivery?orderOptionNos=' + putOrderOptionsReleaseHoldDeliveryRequest.params.orderOptionNos);
        },
        putOrderOptionReserveToNormal: function (putOrderOptionReserveToNormalRequest) {
            return axios.put('/order-options/reserve-to-normal?orderOptionNos=' + putOrderOptionReserveToNormalRequest.params.orderOptionNos);
        },
        getOrderOptionsDetailSummaryView: function (getOrderOptionsDetailSummaryViewRequest) {
            return axios.get('/order-options/detail-summary-view', getOrderOptionsDetailSummaryViewRequest);
        },
        /** @deprecated getOrderOptionsUserSummaryCrm 사용해주세요 */
        getOrderOptionsUserSummaryCry: function (request) {
            return axios.get('/order-options/user-summary-crm', request);
        },
        getOrderOptionsUserSummaryCrm: function (request) {
            return axios.get('/order-options/user-summary-crm', request);
        },
        getOrderOptionUserRecentOrderCrm: function (request) {
            return axios.get('/order-options/user-recent-order-crm', request);
        },
        getOrderOptionCheckReservation: function (request) {
            return axios.get('/order-options/check-reservation', request);
        },
        getOrderOptionCheckReservationV2: function (request) {
            return axios.get('/order-options/check-reservation', request);
        },
        getOrderOptionsUserRecentOrderCrmCount: function (request) {
            return axios.get('/order-options/user-recent-order-crm-count', request);
        },
        putOrderInitializePassword: function (request) {
            return axios.put('/orders/' + request.params.orderNo + '/initialize-password');
        },
        putOrderOrderer: function (request) {
            return axios.put('/orders/' + request.params.orderNo + '/orderer', request.data);
        },
        getOrderOptionsExcelForAssignInvoices: function (request) {
            return axios.get('/order-options/excel-for-assign-invoices', request);
        }
    };
};
